import { Button, Switch, Table, TableContainer, Tbody, Td, Th, Thead, Tr, useToast, Divider, FormControl, FormLabel, Heading, Input, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, useDisclosure, } from "@chakra-ui/react";
import axios from "axios";
import { useState } from "react";
import { ChatState } from "../../../Context/ChatProvider";


const StudentsRestPayement = ({ data, search, loading, setFetchAgain ,setStudentId,getHistoryPayement}) => {
	const { isOpen, onOpen, onClose } = useDisclosure()
	const [id, setId] = useState("");
   
	const [picLoading, setPicLoading] = useState(false);
	const { user } = ChatState();

	const toast = useToast();

	async function getHistory(id,name)
	{
		await setStudentId(id)
		getHistoryPayement(name)
	}

	return (
		
		<>			
			<TableContainer  w={"full"} >
				<Table variant={"simple"} className='border p-2' >

					<Thead>
						<Tr className="bg-gray-50 text-black" >
							<Th textAlign={"center"}>Id</Th>
							<Th textAlign={"center"}>Etudient</Th>
							<Th textAlign={"center"}>nombre des mois non payé</Th>
							<Th textAlign={"center"}>Le prix restant des mois payés</Th>
							
							<Th w={"24"}></Th>
						</Tr>
					</Thead>
					<Tbody >

						{data?.filter((student) => {
							return search.toLowerCase() === ''
								? student
								: student.payementName.toLowerCase().includes(search.toLowerCase());
						})
							.map((student, index) => (

								<Tr key={index} fontSize="sm" bgColor={student.monthsNonPaye>0?'red.100':'white'}>
									
									<Td textAlign={"center"}>{student.id}</Td>
									<Td textAlign={"center"}>{student.name}</Td>
									<Td textAlign={"center"}>{student.monthsNonPaye<0?0:student.monthsNonPaye}</Td>
									<Td textAlign={"center"}>{student.restPayement}</Td>
                                    
									<Td>	
										<Button _focus={{ boxShadow: "none" }} className="flex items-center align-middle h-20 ml-5" bg='gray.50' onClick={()=>getHistory(student.id,student.name)}><i className={`fa-solid fa-history mr-2 ${student.monthsNonPaye>0?' text-red-400':' text-blue-400'}`}></i> <p>Historique des paiements</p>  </Button>
										</Td>
									
									
								</Tr>

							))}
					</Tbody>


				</Table>
				<div className="w-full  flex item-center p-6">
					
					{!loading && data.length === 0 && <span className="text-md text-gray-300 m-auto">Aucun résultat.</span>}
				</div>
			</TableContainer>
		</>
	);


};

export default StudentsRestPayement;
